const SKIN_TYPES = [
  'Normal',
  'Dry',
  'Combination',
  'Oily',
];

export default SKIN_TYPES;
